<div class="top">
  <div class="heading">
    <span class="fw-bold">CREATE VEHICLE</span>
  </div>
  <i class="material-icons text-danger" role="button" (click)="closeModal()">
    close
  </i>
</div>

<div class="form-wrapper">
  <form [formGroup]="form" (ngSubmit)="openConfirmModal()">
    <div class="form-fields">
      <div class="row">
        <div class="col-md-12">
          <div class="field">
            <label for="name" class="required">VEHICLE NAME</label>
            <input
              type="text"
              class="form-control"
              formControlName="typeOfVehicle"
              placeholder="vehicle name"
            />
            <app-error-message
              [form]="form"
              controlName="typeOfVehicle"
              label="Vehicle Name"
              [showErrorMessage]="showErrorMessages"
            ></app-error-message>
          </div>
        </div>
        <div class="col-md-12">
          <div class="field">
            <label for="price" class="required">PRICE</label>
            <input
              type="number"
              class="form-control"
              formControlName="ticketAmount"
              placeholder="ticket price"
              min="0"
            />
            <app-error-message
              [form]="form"
              controlName="ticketAmount"
              label="Price"
              [showErrorMessage]="showErrorMessages"
            ></app-error-message>
          </div>
        </div>
        <div class="col-md-12">
          <div class="field">
            <label for="name" class="required">LGA</label>

            @if(!lgas){
            <ngx-skeleton-loader class="input-skeleton"></ngx-skeleton-loader>
            } @else{

            <ng-select
              [items]="lgas"
              [multiple]="false"
              [closeOnSelect]="true"
              [searchable]="true"
              [hideSelected]="false"
              bindLabel="formattedName"
              bindValue="id"
              placeholder="Select"
              formControlName="lga"
              class="ng-select control role-select"
            >
            </ng-select>

            }
            <app-error-message
              [form]="form"
              controlName="lga"
              label="LGA"
              [showErrorMessage]="showErrorMessages"
            ></app-error-message>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-actions-wrapper">
      <button
        type="submit"
        class="custom-btn-primary w-100"
        [disabled]="form.invalid || isSubmitting"
      >
        <ng-container *ngIf="!isSubmitting; else loadingTemplate">
          <span>Create Vehicle</span>
        </ng-container>
        <ng-template #loadingTemplate>
          <span>Creating Vehicle...</span>
          <div class="spinner-light"></div>
        </ng-template>
      </button>
    </div>
  </form>
</div>
